import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";
function Loading_Breadcrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid ">
      {vPathName === "/Loading" ? (
        <div>
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            Loading{" "}
          </span>
        </div>
      ) : vPathName === "/LoadingDetail" ? (
        <div className="d-flex align-items-center">
          <Link
            to="/Loading"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
            Loading
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <div>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              LoadingDetail{" "}
            </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default Loading_Breadcrumbs;
